// This modal shows the info to be replicated and a table of the debtors that can be selected to replicate the updates to

import { Alert, Button, message, Modal, Space, Table } from "antd";
import { useFetchDebtorsQuery } from "features/debtorProfile/debtorProfileAPI";
import { useState } from "react";
import { useParams } from "react-router-dom";
import styled from "styled-components";

const StyledSpace = styled(Space)`
  width: 100%;
`;

export default function ReplicatePacketedDebtorUpdatesModal({
  replicatePacketedDebtorData,
  packetId,
  onCancel,
  onOk,
}) {
  const { data: packetedDebtors, isLoading } = useFetchDebtorsQuery(
    {
      filters: {
        debtorPacketIds: [packetId],
      },
    },
    {
      skip: !packetId,
    },
  );
  // data refers to address, email, phone, or debtor info fields
  const { dataId, newData, action, type, changedFields, debtorId } = replicatePacketedDebtorData;
  const [selectedDebtors, setSelectedDebtors] = useState([]);
  const hasSelected = selectedDebtors.length > 0;
  const { debtorId: currentDebtorId } = useParams();
  const columns = [
    {
      title: "Debtor Name",
      dataIndex: "name",
      key: "name",
      width: 200,
      render: (text, record) => (
        <Button
          type="link"
          onClick={() => {
            window.open(`/debtors/${record.id}`, "_blank");
          }}
        >
          {text || `Debtor ${record.id}`}
        </Button>
      ),
    },
    {
      title: "External ID",
      dataIndex: "externalId",
      width: 300,
      key: "externalId",
    },
    {
      title: "# of Accounts",
      width: 50,
      render: (text, record) => record.accountIds?.length || 0,
    },
  ];

  if (!packetId) return null;
  return (
    <Modal
      maskClosable={false}
      open
      onCancel={onCancel}
      title={`Replicate ${type} change to selected packeted debtors`}
      okText="Replicate"
      onOk={async () => {
        const payload = changedFields
          ? // This allows us to perform partial data replication for debtor info
            { packetId, debtorId, targetDebtorIds: selectedDebtors, ...changedFields }
          : // This one is used by the debtor objects replication (email, phone, address...)
            { packetId, dataId, targetDebtorIds: selectedDebtors };
        const result = await action(payload);
        if ("data" in result) {
          message.success(
            `The new ${type} has been replicated to the selected packeted debtors successfully`,
          );
          onOk();
        }
      }}
      okButtonProps={{ disabled: !hasSelected }}
      width={900}
    >
      <StyledSpace direction="vertical">
        <Alert message={`New ${type} change: ${newData}`} type="warning" showIcon />
        <Table
          scroll={{ x: "max-content" }}
          loading={isLoading}
          dataSource={packetedDebtors?.results?.filter(
            (debtor) => debtor.id.toString() !== currentDebtorId.toString(),
          )}
          rowKey="id"
          columns={columns}
          rowSelection={{
            type: "checkbox",
            onChange: (selectedRows) => {
              setSelectedDebtors(selectedRows);
            },
          }}
        />
      </StyledSpace>
    </Modal>
  );
}
